const AsyncStorage = localStorage

export const onSignOut = () => AsyncStorage.removeItem("hg_app_s");
export const verifica = () => {

  return new Promise((resolve, reject) => {
    let res = AsyncStorage.getItem("hg_app_s")
    res = isObject(res)
    if (typeof res === 'object') {
      resolve(res);
    } else {
      resolve(false);
    }
  });
};

function isObject (text) {
  //Si el parametro text es de tipo string pasa al siguiente if
  if(typeof text === 'string') {
    //El parametro text entra a identificarse si puede ser un objeto
    if (/^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, '')))
      //El parametro text regresa de tipo objeto
    return JSON.parse(text)
    else
      return undefined
  }
  else if(typeof text === 'object')
    return text
  else
    return undefined
}